import { useEffect, useState } from 'react'
import { MODAL_FROM_CONTEXTS } from 'store/ui/actions'
import SearchInput from 'components/misc/SearchInput'
import styles from './styles/SearchCites.css'

export const SearchCites = ({
  textMatch,
  setTextMatch,
  fullReport,
  toggleModal,
  upgradeReport,
  debounceMatch = false
}) => {
  const [value, setValue] = useState(textMatch)

  //
  // In the case where e.g. the user clicked back/forward
  //
  useEffect(() => {
    if (value !== textMatch) {
      setValue(textMatch)
    }
  }, [textMatch])

  const handleFocus = () => {
    if (!fullReport) {
      toggleModal(upgradeReport ? 'upgrade' : 'login', true, MODAL_FROM_CONTEXTS.REPORT_SEARCH)
    }
  }

  return (
    <div className={styles.layout}>
      <SearchInput
        className={styles.search}
        inputClass={styles.input}
        value={value}
        onChange={e => {
          setValue(e.target.value)
          setTextMatch(e.target.value, debounceMatch)
        }}
        placeholder='Context, author(s), title etc.'
        onFocus={handleFocus}
        label='search citations'
      />
    </div>
  )
}

export default SearchCites
